import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {
  CreateStripeSessionParamsPost,
  CreditEntityGetParams,
  CreditEntityModel,
  PricingModel,
  SMValue,
} from '../_models/subscription.types';
import { QrCodeParserRequest } from '../_models/qrCodeParser/qrCodeParserRequest';
import { QrCodeParserResponsePlanActivation } from '../_models/qrCodeParser/qrCodeParserResponsePlanActivation';
import { QrCodeParserResponseDeviceCreation } from '../_models/qrCodeParser/qrCodeParserResponseDeviceCreation';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  private subscriptionServiceUrl = `${environment.subscriptionServiceUrl}`;

  constructor(private http: HttpClient) {}

  // Get credit entity by module, entity and store modules
  getCreditEntity(params: CreditEntityGetParams): Observable<CreditEntityModel[]> {
    let queryParameters = new HttpParams().set('module', params.module);

    params.storeModules.forEach((sm) => {
      queryParameters = queryParameters.append('storeModules', sm);
    });

    return this.http.get<CreditEntityModel[]>(
      `${this.subscriptionServiceUrl}api/private/v1/credit/entity`,
      {
        params: queryParameters,
      }
    );
  }

  // Assign fields to the credit entity
  postActivateFieldsEntity(params: { fieldIds: number[] }): Observable<void> {
    return this.http.post<void>(
      `${this.subscriptionServiceUrl}api/private/v1/credit/irrigation/fields/activate`,
      params
    );
  }

  // Update plan with QR code
  parsePlan(request: QrCodeParserRequest): Observable<QrCodeParserResponsePlanActivation> {
    return this.http
      .post<QrCodeParserResponseDeviceCreation>(
        `${this.subscriptionServiceUrl}api/private/v2/parser/qrcode`,
        request
      )
      .pipe(map((response) => response));
  }

  // Get store model pricing
  getPricing(storeModel: SMValue, countryCode: string): Observable<PricingModel[]> {
    const queryParameters = new HttpParams();
    return this.http.get<PricingModel[]>(
      `${this.subscriptionServiceUrl}api/private/v1/pricing/${countryCode}/${storeModel}`,
      { params: queryParameters }
    );
  }

  // Stripe - Create Session
  createStripeSession(params: CreateStripeSessionParamsPost): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(
      `${this.subscriptionServiceUrl}api/private/v1/store/stripe/createSession`,
      params
    );
  }
}
